(function () {
    'use strict';

    angular.module('app.paymentTransactions', [
        'app.core',
        'app.widgets'
    ]);
})();
